import React from 'react'
import { InlineDisplayContent } from './InlineDisplayContent'

export const InlineDisplayEmptyContent = ({ className = 'text-warning font-italic small', emptyContent = '--', ...rest }) => {
  return <InlineDisplayContent {...{ ...rest, value: <span className={className}>{emptyContent}</span> }} />
}
